import { alpha } from '@mui/material/styles';
import { DARK_TEXT } from './brandColors';

// The editorial type scale. Theme h1–h6 are fontWeight 700; this brief's voice
// needs 900 and negative tracking, so these override explicitly.
//
// The core device is a big tabular numeral paired with LABEL_MICRO. Use it
// relentlessly — premium here comes from type and motion, not decoration.

export const NUMERAL_HERO = {
  fontSize: { xs: 56, sm: 64 },
  fontWeight: 900,
  lineHeight: 0.9,
  letterSpacing: '-0.04em',
  fontVariantNumeric: 'tabular-nums',
};

export const NUMERAL_LG = {
  fontSize: 40,
  fontWeight: 900,
  lineHeight: 1,
  letterSpacing: '-0.03em',
  fontVariantNumeric: 'tabular-nums',
};

export const NUMERAL_MD = {
  fontSize: 24,
  fontWeight: 800,
  lineHeight: 1.1,
  fontVariantNumeric: 'tabular-nums',
};

export const LABEL_MICRO = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: 'text.secondary',
};

export const LABEL_MICRO_ON_RED = {
  ...LABEL_MICRO,
  color: 'rgba(255,255,255,0.7)',
};

export const LABEL_MICRO_ON_YELLOW = {
  ...LABEL_MICRO,
  color: alpha(DARK_TEXT, 0.7),
};

export const LABEL_SM = {
  fontSize: 12,
  fontWeight: 600,
  color: 'text.secondary',
};

export const TITLE_SECTION = {
  fontWeight: 800,
  letterSpacing: '-0.01em',
  color: 'text.primary',
};
